import React, { memo } from 'react';
import { OverridableComponent } from '@mui/material/OverridableComponent';

interface IProps {
  addressName?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  countryDisplay?: string;
  component?: React.ComponentType<React.PropsWithChildren<{ children: React.ReactNode }>>;
}

type TypeMap<D extends React.ElementType = 'p'> = {
  props: IProps;
  defaultComponent: D;
  classKey: string;
};

const AddressInfo: React.FC<React.PropsWithChildren<IProps>> = ({
  addressName,
  address1,
  address2,
  city,
  state,
  postalCode,
  countryDisplay,
  component: Component,
  ...props
}) => {
  const fragments = [[addressName], [address1], [address2], [city, state, postalCode, countryDisplay]].map(
    (values, index, { length }) => {
      const line = values.filter(Boolean).join(', ');
      if (!line) return null;
      return (
        <div key={String(line)}>
          {line}
          {index < length - 1 && <br />}
        </div>
      );
    },
  );

  if (Component) return <Component {...props}>{fragments}</Component>;
  return <div key="addresses">{fragments}</div>;
};
export default memo(AddressInfo) as OverridableComponent<TypeMap>;
